module.exports = __webpack_public_path__ + "static/media/experience.71745a85.svg";